import { h, ComponentChildren } from "preact";

import classname from "../../../foundation/utils/classname";
import { imageUrl } from "../../../foundation/utils/image";

import styles from "./DropdownItem.module.css";

interface DropdownItemProps<V = undefined> {
    class?: string;
    /** Text or children to be displayed in the `Dropdown` when the item is selected. */
    label?: ComponentChildren;
    /** Text or children to be displayed in the `Dropdown` button, if given */
    dropdownLabel?: ComponentChildren;
    /** Value provided when the item is selected. */
    value: V;
    /** Title for the div element of item */
    labelTitle?: string;
    /** Current selection state of the item. Default: `false` */
    selected?: boolean;
    /** Whether to show a check mark if the item is selected. Default: `true` */
    showCheck?: boolean;
    /** Whether this item is a child of Dropdown.ParentItem */
    // `subItem` prop is used in `cloneDropdownItems` util function
    subItem?: boolean;
    /** Children to be rendered inside item. If not provided, the label will be rendered. */
    children?: ComponentChildren;
    /** Callback to be called when the item is selected. */
    onSelect?: (value: V) => void;
    /** Callback to be called when the item is hovered. */
    onHover?: () => void;
}

function DropdownItem<V>({
    class: cssClass,
    label,
    value,
    labelTitle,
    selected = false,
    showCheck = true,
    children,
    onSelect,
    onHover
}: DropdownItemProps<V>) {
    function handleClick(ev: Event) {
        ev.stopPropagation();
        onSelect?.(value);
    }

    function handleMouseEnter() {
        onHover?.();
    }

    const classes = classname(styles.dropdownItem, "noSelect", cssClass, { selected });

    return (
        <div
            class={classes}
            title={labelTitle}
            onClick={handleClick}
            onMouseEnter={handleMouseEnter}>
            <div class={classname(styles.dropdownItemContent, "ellipsis")}>
                {children || label}
            </div>
            {showCheck && selected && <img class={styles.dropdownCheck} src={imageUrl("img/icMenuCheck.svg")} alt="&check;"/>}
        </div>
    );
}

export { DropdownItemProps };
export default DropdownItem;
